import useAxios from 'hooks/useAxios';

export const getCostReport = (filters = {}) => {
  const api = useAxios();

  const { startDate, endDate, clientId, operatorId, brandId } = filters;

  const params = {};

  // Only include dates if provided (supports "all time" when both are null)
  if (startDate) {
    params.startDate = startDate;
  }
  if (endDate) {
    params.endDate = endDate;
  }

  // Entity filters - only include if non-empty string (UUID validation on backend)
  if (clientId && clientId.trim()) {
    params.clientId = clientId;
  }
  if (operatorId && operatorId.trim()) {
    params.operatorId = operatorId;
  }
  if (brandId && brandId.trim()) {
    params.brandId = brandId;
  }

  return api.get('/session/game-playtime', { params });
};

export const exportCostReport = (filters = {}) => {
  const api = useAxios();

  const { startDate, endDate, clientId, operatorId, brandId } = filters;

  const params = {};

  if (startDate) {
    params.startDate = startDate;
  }
  if (endDate) {
    params.endDate = endDate;
  }
  // Entity filters - only include if non-empty string
  if (clientId && clientId.trim()) {
    params.clientId = clientId;
  }
  if (operatorId && operatorId.trim()) {
    params.operatorId = operatorId;
  }
  if (brandId && brandId.trim()) {
    params.brandId = brandId;
  }

  return api.get('/session/game-playtime', {
    params,
    responseType: 'blob'
  });
};
